/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * WordPress dependencies
 */
export * from '@wordpress/data';
import {
	register as doRegister,
	resolveSelect as doResolveSelect,
	subscribe as doSubscribe,
	useSelect as doUseSelect,
} from '@wordpress/data';
import type {
	MapSelect,
	ReduxStoreConfig,
	StoreDescriptor,
	UseSelectReturn,
} from '@wordpress/data/build-types/types';

// ==========
// TYPESCRIPT
// ==========

// register should exist.
export function register(
	store: StoreDescriptor< ReduxStoreConfig< any, any, any > >
): void {
	doRegister( store );
}

// subscribe should exist.
export function subscribe(
	listener: () => void,
	store?: StoreDescriptor< any > | string
): () => void {
	return doSubscribe( listener, store );
}

// useSelect should properly infer types, but it doesn’t, so we manually fix it.
export function useSelect< T extends MapSelect | StoreDescriptor< any > >(
	mapSelect: T,
	dependencies?: unknown[]
): UseSelectReturn< T > {
	return doUseSelect< T >( mapSelect, dependencies );
}

// resolveSelect should properly infer types, but it doesn’t, so we manually fix it.
export function resolveSelect< T extends StoreDescriptor< any > >(
	key: T
): ResolvableSelectors< UseSelectReturn< T > > {
	return doResolveSelect( key ) as unknown as ResolvableSelectors<
		UseSelectReturn< T >
	>;
}

type ResolvableSelectors<
	S extends Record< string, ( ...args: any[] ) => any >,
> = {
	readonly [ K in keyof S ]: S[ K ] extends {
		PromisedSignature: ( ...args: any[] ) => any;
	}
		? S[ K ][ 'PromisedSignature' ]
		: S[ K ] extends ( ...args: infer A ) => infer R
		? ( ...args: A ) => Promise< R >
		: never;
};
